import exampleDiag from "assets/img/k8s-attr-diag.png";
import * as React from 'react';
export default {
  exampleDiag,
  React
};